module.exports = __webpack_public_path__ + "assets/6affbacb63365133787f0351828d46fd.png";